export class CashPaymentOrder {
    public orderCode: string;
    public amount: number;
}

export class PaySafe {
    public cashPaymentOrders: CashPaymentOrder[];
    public orderCodes: string;
    public amount: number;
    public paySafeUrl: string;
    public paySafeMerchantID: string;
    public paySafeReference: string;
}
